<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :showModeOpenId="showModeOpenId"
                :viewParams="viewParams"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <QuotationForm :formProps="formProps">
                </QuotationForm>
            </template>
            <template #search="searchProps">
                <QuotationSearch :searchProps="searchProps">
                </QuotationSearch>
            </template>

            <template #buttons>
                <BackButton v-if="showReturnToStagesButton"
                            :backFunction="goToStages" />
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { router } from '@inertiajs/vue3'
import QuotationForm from './QuotationForm.vue'
import QuotationSearch from './QuotationSearch.vue'
import Button from "primevue/button";
import BackButton from '@crud/BackButton.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __, getFromUrl, screenMessage } from '@pages/Helper/utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    viewParams: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()
const showReturnToStagesButton = ref(false)

if (props.viewParams?.project_id) {
    showReturnToStagesButton.value = true
}
//------------------------------------------------------------------------------

const goToStages = () => {
    router.visit(route('project-stages-view', {
        projectId: props.viewParams?.project_id,
        backToView: props.viewParams?.backToView ? 1 : 0
    }), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
